import template from './collectors.html';
import controller from './collectors.controller';
import './collectors.scss';

let CollectorsComponent = {
  bindings: {
    collectorsObservable: '<',
    posObservable: '<'
  },
  template,
  controller
};

export default CollectorsComponent;



// WEBPACK FOOTER //
// ./src/app/pages/collectors/collectors.component.js